import { Translations } from './types';
import { operationsTranslations } from './operations';

const pl: Translations = {
  webUpdate: {
    title: 'Dostępna nowa wersja %s',
    message: 'Zapisz rozpoczętą pracę. Odśwież aplikację, aby załadować najnowszą wersję.',
    refresh: 'Odśwież i zaktualizuj',
    updating: 'Ładowanie nowej wersji…',
    error: 'Nie udało się pobrać pełnej aktualizacji. Sprawdź połączenie i spróbuj ponownie.',
    unavailable: 'Ogłoszona wersja nie jest jeszcze dostępna na tym serwerze. Spróbuj ponownie za chwilę.',
    download: 'Pobieranie aktualizacji nie powiodło się. Obecna wersja nadal działa. Spróbuj ponownie.',
    activation: 'Nie udało się uruchomić pobranej aktualizacji. Spróbuj ponownie.',
    timeout: 'Pobieranie aktualizacji trwa zbyt długo. Spróbuj ponownie za chwilę.',
  },
  operations: operationsTranslations.pl,
  tabs: {
    home: 'Główna',
    inventory: 'Katalog sprzętu',
    stores: 'Magazyny',
    categories: 'Kategorie',
    usage: 'Ewidencja',
    admin: 'Admin',
    documents: 'Dokumenty',
    auditLogs: 'Dziennik audytu',
    reports: 'Raporty',
    profile: 'Mój profil',
  },
  common: {
    cancel: 'Anuluj',
    save: 'Zapisz',
    delete: 'Usuń',
    edit: 'Edytuj',
    add: '+ Dodaj',
    new: '+ Nowy',
    error: 'Błąd',
    validation: 'Walidacja',
    noAccess: 'Brak dostępu',
    confirm: 'Potwierdź',
    del: 'Usuń',
    open: 'Otwórz',
    change: 'Zmień',
    namePlaceholder: 'Nazwa',
    descriptionPlaceholder: 'Opis (opcjonalnie)',
    unknownUser: 'Nieznany użytkownik',
    done: 'Gotowe',
  },
  login: {
    title: 'GOPR Inventory',
    subtitle: 'Zarządzanie Sprzętem Ratownictwa Górskiego',
    signInWithGoogle: 'Zaloguj przez Google',
    loginFailed: 'Błąd logowania Google',
    cancelled: 'Logowanie Google zostało anulowane.',
    popupBlocked: 'Popup zablokowany przez przeglądarkę. Zezwól na popupy dla tej strony.',
    unauthorizedDomain: 'Ta domena nie jest autoryzowana do logowania Google. Skontaktuj się z administratorem.',
    onlyGoprAllowed: 'Dostęp tylko dla użytkowników @bieszczady.gopr.pl.',
    playServicesUnavailable: 'Usługi Google Play są niedostępne na tym urządzeniu.',
    signInRequired: 'Wymagane jest logowanie Google. Spróbuj ponownie.',
    emailLabel: 'Email',
    emailPlaceholder: 'Adres email',
    passwordLabel: 'Hasło',
    passwordPlaceholder: 'Hasło',
    signInWithEmail: 'Zaloguj',
    orSignInWithEmail: 'Zaloguj przez email i hasło',
    hideEmailForm: 'Ukryj',
    emailLoginFailed: 'Błąd logowania',
    invalidCredentials: 'Nieprawidłowy email lub hasło.',
    userNotFound: 'Nie znaleziono konta z tym adresem email.',
    emailRequired: 'Adres email jest wymagany.',
    passwordRequired: 'Hasło jest wymagane.',
  },
  home: {
    welcome: 'Witaj,',
    yourPermissions: 'Twoje Uprawnienia',
    noPermissions: 'Brak dostępu. Skontaktuj się z administratorem.',
    permViewInventory: '✓ Przeglądaj sprzęt i stany magazynowe\n✓ Twórz zapisy ewidencji',
    permManage: '✓ Zarządzaj sprzętem i magazynami\n✓ Zarządzaj kategoriami',
    permAdmin: '✓ Zarządzaj rolami użytkowników\n✓ Pełny dostęp do systemu',
    signOut: 'Wyloguj',
    language: 'Język',
    guestNotice: 'W celu nadania dostępu do aplikacji GOPR Inventory skontaktuj się z l.derwich@bieszczady.gopr.pl',
    contactButton: 'Wyślij wiadomość',
    contactEmailSubject: 'Prośba o dostęp do GOPR Inventory',
    contactEmailBody: 'Dzień dobry,\n\nProszę o nadanie dostępu do aplikacji GOPR Inventory.\n\nPozdrawiam,',
    navigation: {
      usage: 'Ewidencja',
      inventory: 'Katalog sprzętu',
      stores: 'Magazyny',
      admin: 'Administracja',
      documents: 'Dokumenty',
      auditLogs: 'Dziennik audytu',
      reports: 'Raporty',
    },
  },
  inventory: {
    itemType: 'Typ przedmiotu',
    disposable: 'Jednorazowy',
    reusable: 'Wielorazowy',
    reusableHint: 'Użycie jest zliczane bez zmniejszania stanu magazynowego.',
    title: 'Katalog sprzętu',
    addTitle: 'Dodaj Sprzęt',
    editTitle: 'Edytuj Sprzęt',
    noItems: 'Brak sprzętu w katalogu.',
    categoryLabel: 'Kategoria',
    unitLabel: 'Jednostka',
    unitPlaceholder: 'Jednostka (np. szt.)',
    minQuantityLabel: 'Min. ilość',
    minQuantityPlaceholder: 'Min. ilość (domyślne)',
    validationMessage: 'Nazwa, kategoria i jednostka są wymagane.',
    confirmDelete: 'Usuń "%s"?',
  },
  categories: {
    title: 'Kategorie',
    addTitle: 'Dodaj Kategorię',
    editTitle: 'Edytuj Kategorię',
    addSubcategoryTitle: 'Dodaj Podkategorię',
    noItems: 'Brak kategorii.',
    noInventoryItems: 'Brak sprzętu w tej kategorii.',
    validationMessage: 'Nazwa jest wymagana.',
    confirmDelete: 'Usuń kategorię "%s"?',
    hasSubcategoriesError: 'Nie można usunąć: kategoria ma podkategorie.',
    cannotAddInventoryError: 'Nie można dodać sprzętu: kategoria ma podkategorie.',
    cannotAddSubcategoryError: 'Nie można dodać podkategorii: kategoria zawiera już sprzęt.',
    addEquipmentHere: '+ Dodaj Sprzęt',
    addSubcategoryHere: '+ Dodaj Podkategorię',
    parentCategoryLabel: 'Kategoria nadrzędna',
    rootCategory: 'Brak (poziom główny)',
    weightLabel: 'Kolejność',
    weightPlaceholder: 'Kolejność (np. 1)',
    requiresActionNumber: 'Wymagaj numeru akcji',
  },
  stores: {
    title: 'Magazyny',
    addTitle: 'Dodaj Magazyn',
    editTitle: 'Edytuj Magazyn',
    noItems: 'Brak magazynów.',
    namePlaceholder: 'Nazwa magazynu',
    nameRequired: 'Nazwa magazynu jest wymagana.',
    weightLabel: 'Kolejność',
    weightPlaceholder: 'Kolejność (np. 1)',
    stockTitle: '📦 %s — Stan',
    noStock: 'Brak zapisanego stanu.',
    confirmDelete: 'Usuń magazyn "%s"?',
    revealAll: 'Rozwiń',
    collapseAll: 'Zwiń',
    setLimits: 'Limity',
    limitsTitle: 'Minimalne limity — %s',
    belowLimit: 'Poniżej limitu',
    limitsDefaultHint: 'domyślnie: %s',
    viewUsageHistory: 'Historia',
    orderButton: 'Zamówienie',
    orderHistory: 'Zamówienia',
    orderCategories: 'Kategorie sprzętu',
    orderEquipment: 'Sprzęt do zamówienia',
    orderSummary: 'Podsumowanie zamówienia',
    orderSelectCategories: 'Wybierz kategorie sprzętu do zamówienia.',
    orderNoEquipment: 'Brak sprzętu w tej kategorii.',
    orderCurrentStock: 'Aktualny stan: %s',
    orderNotes: 'Uwagi',
    orderNotesPlaceholder: 'Opcjonalne uwagi do zamówienia',
    orderConfirm: 'Zapisz i generuj XLSX',
    orderEmpty: 'Dodaj co najmniej jedną pozycję z ilością większą od zera.',
    orderCreated: 'Zamówienie zapisane',
    orderCreatedMessage: 'Trwa generowanie XLSX. Plik zostanie wysłany e-mailem i pojawi się w historii zamówień.',
    orderRefresh: 'Odśwież',
    orderAllStores: 'Wszystkie magazyny',
    orderAuthor: 'Utworzył',
    orderStatusPending: 'Generowanie',
    orderStatusDone: 'Gotowe',
    orderStatusError: 'Błąd',
    orderDownload: 'Pobierz XLSX',
    orderNoOrders: 'Brak zamówień.',
  },
  usage: {
    title: 'Ewidencja',
    newRecord: 'Nowy Wpis Ewidencji',
    noItems: 'Brak wpisów ewidencji.',
    typeLabel: 'Typ',
    equipmentLabel: 'Sprzęt',
    fromStoreLabel: 'Z Magazynu',
    toStoreLabel: 'Do Magazynu',
    quantityPlaceholder: 'Ilość',
    notePlaceholder: 'Notatka (opcjonalnie)',
    qtyLabel: 'Ilość',
    fromLabel: 'Z',
    toLabel: 'Do',
    validationEquipment: 'Sprzęt i prawidłowa ilość są wymagane.',
    validationFromStore: 'Magazyn źródłowy jest wymagany dla operacji pobierania.',
    validationToStore: 'Magazyn docelowy jest wymagany dla operacji dodawania.',
    validationTransfer: 'Magazyny źródłowy i docelowy są wymagane dla transferu.',
    recordCreated: 'Wpis ewidencji zapisany',
    recordCreatedMessage: 'Wpis ewidencji został pomyślnie utworzony.',
    typeTake: 'POBIERZ',
    typeAdd: 'DODAJ',
    typeTransfer: 'PRZENIEŚ',
    typeStocktaking: 'REMANENT',
    wizardStepInfo: 'Informacje podstawowe',
    wizardStepCategories: 'Kategorie sprzętu',
    wizardStepEquipment: 'Sprzęt',
    wizardStepReview: 'Sprawdź listę',
    wizardStepSummary: 'Podsumowanie',
    wizardDateLabel: 'Data',
    wizardTimeLabel: 'Godzina',
    wizardStoreLabel: 'Magazyn',
    wizardActionNumberLabel: 'Numer akcji',
    wizardActionNumberPlaceholder: 'np. 12/05/2026 (opcjonalnie)',
    wizardDescriptionLabel: 'Opis',
    wizardDescriptionPlaceholder: 'Opis zdarzenia (opcjonalnie)',
    wizardSelectCategories: 'Zaznacz kategorie sprzętu użytego w akcji',
    wizardNoEquipment: 'Brak sprzętu w tej kategorii.',
    wizardReviewItems: 'Lista użytego sprzętu',
    wizardAddItem: 'Dodaj brakujący sprzęt',
    wizardSearchPlaceholder: 'Szukaj sprzętu...',
    wizardNoItemsAdded: 'Nie dodano żadnego sprzętu.',
    wizardConfirm: 'Zatwierdź i zapisz',
    wizardInvalidDate: 'Nieprawidłowy format daty (DD.MM.RRRR) lub godziny (GG:MM).',
    wizardDateOutOfRange: 'Data akcji nie może być w przyszłości ani starsza niż 30 dni.',
    wizardStoreRequired: 'Wybierz magazyn, z którego pochodzi sprzęt.',
    wizardBack: 'Wstecz',
    wizardNext: 'Dalej',
    wizardSummaryDate: 'Data i godzina',
    wizardSummaryStore: 'Magazyn',
    wizardSummaryFromStore: 'Z Magazynu',
    wizardSummaryToStore: 'Do Magazynu',
    wizardSummaryType: 'Typ operacji',
    wizardSummaryAction: 'Numer akcji',
    wizardSummaryDescription: 'Opis',
    wizardSummaryItems: 'Użyty sprzęt',
    wizardTypeLabel: 'Typ operacji',
    wizardFromStoreLabel: 'Z Magazynu',
    wizardToStoreLabel: 'Do Magazynu',
    wizardFromStoreRequired: 'Wybierz magazyn źródłowy.',
    wizardToStoreRequired: 'Wybierz magazyn docelowy.',
    wizardBothStoresRequired: 'Wybierz magazyn źródłowy i docelowy.',
    wizardViewFull: 'Pełna lista',
    wizardViewCategorized: 'Kategorie',
    wizardStockAvailable: 'W magazynie: %s',
    wizardExceedsStock: 'Ilość przekracza stan magazynowy (%s).',
    wizardStoreStocktakingLabel: 'Magazyn (spis z natury)',
    wizardStocktakingHint: 'Zaznacz sprzęt do weryfikacji i ustaw aktualne ilości',
    wizardActionNumberInfo: 'Numer akcji może być wymagany dla niektórych kategorii sprzętu.',
    wizardActionNumberFormatError: 'Numer akcji musi mieć format: LICZBA/LICZBA/LICZBA (np. 12/05/2026).',
    wizardCategoryRequiresActionNumber: 'Wymagany numer akcji',
    sessionItemsLabel: 'Użyty sprzęt',
    sessionItemsLabelAdd: 'Dodany sprzęt',
    sessionItemsLabelTransfer: 'Przeniesiony sprzęt',
    sessionItemsLabelStocktaking: 'Zweryfikowany sprzęt',
    sessionItemsCount: 'Pozycji: %s',
    storeHistoryTitle: 'Ewidencja — %s',
    createdBy: 'Dodane przez',
    searchByActionNumber: 'Szukaj po nr akcji',
    searchPlaceholder: 'Numer akcji (np. 12/05/2026)',
    searchButton: 'Szukaj',
    searchTitle: 'Wyniki: %s',
    searchNoResults: 'Brak wyników dla "%s"',
  },
  admin: {
    title: 'Administracja',
    noAccess: 'Wymagany dostęp administratora',
    changeRole: 'Zmień Rolę',
    changeRoleMessage: 'Zmienić rolę %s na %s?',
    noUsers: 'Brak użytkowników.',
    createdAt: 'Utworzono',
    lastLoginAt: 'Ostatnie logowanie',
    never: 'Nigdy',
    filterAll: 'Wszyscy',
    userManagement: 'Zarządzanie Użytkownikami',
    userManagementDesc: 'Przeglądaj użytkowników i zarządzaj ich rolami.',
    scheduler: 'Harmonogram',
    schedulerDesc: 'Zarządzaj automatycznymi zadaniami (np. generowanie raportów).',
  },
  scheduler: {
    title: 'Harmonogram',
    noAccess: 'Wymagany dostęp administratora',
    noTasks: 'Brak zaplanowanych zadań.',
    addTask: '+ Dodaj zadanie',
    editTask: 'Edytuj zadanie',
    deleteTask: 'Usuń',
    deleteConfirm: 'Usunąć to zadanie?',
    enabledLabel: 'Włączone',
    scheduleLabel: 'Harmonogram',
    reportTypeLabel: 'Typ raportu',
    recipientsLabel: 'Odbiorcy (email)',
    recipientPlaceholder: 'Adres email odbiorcy',
    addRecipient: 'Dodaj odbiorcę',
    periodLabel: 'Okres',
    saveTask: 'Zapisz zadanie',
    typeLabel: 'Typ zadania',
    scheduleDaily: 'Codziennie',
    scheduleWeekly: 'Co tydzień',
    scheduleMonthly: 'Co miesiąc',
    dayOfWeekLabel: 'Dzień tygodnia',
    dayOfMonthLabel: 'Dzień miesiąca',
    weekDaySun: 'Nd',
    weekDayMon: 'Pn',
    weekDayTue: 'Wt',
    weekDayWed: 'Śr',
    weekDayThu: 'Cz',
    weekDayFri: 'Pt',
    weekDaySat: 'Sb',
    periodNone: 'Brak (bez zakresu dat)',
    periodLast7Days: 'Ostatnie 7 dni',
    periodLastWeek: 'Poprzedni tydzień (pon–nd)',
    periodLastMonth: 'Poprzedni miesiąc',
    periodLastYear: 'Poprzedni rok',
    periodCurrentWeek: 'Bieżący tydzień (pon–dziś)',
    periodCurrentMonth: 'Bieżący miesiąc',
    validationRecipients: 'Co najmniej jeden odbiorca jest wymagany.',
    enabledStatus: 'Aktywne',
    disabledStatus: 'Nieaktywne',
  },
  auditLogs: {
    title: 'Dziennik Audytu',
    noAccess: 'Wymagany dostęp administratora',
    noLogs: 'Brak wpisów audytu.',
    entity: 'Obiekt',
    action: 'Akcja',
    user: 'Użytkownik',
    timestamp: 'Data',
    details: 'Szczegóły',
    entityTypes: {
      operations: 'Zadania i partie',
      category: 'Kategoria',
      equipment: 'Sprzęt',
      store: 'Magazyn',
      usage: 'Ewidencja',
      document: 'Dokument',
      user: 'Użytkownik',
    },
    actions: {
      create: 'Utwórz',
      edit: 'Edytuj',
      delete: 'Usuń',
      update: 'Aktualizuj',
      login: 'Logowanie',
    },
  },
  documents: {
    title: 'Dokumenty',
    addTitle: 'Dodaj Dokument',
    editTitle: 'Edytuj Dokument',
    noItems: 'Brak dokumentów.',
    titleLabel: 'Tytuł',
    titlePlaceholder: 'Tytuł dokumentu',
    urlLabel: 'Link do PDF',
    urlPlaceholder: 'https://...',
    validationMessage: 'Tytuł i link do PDF są wymagane.',
    confirmDelete: 'Usuń dokument "%s"?',
    open: 'Otwórz',
  },
  contact: {
    title: 'Kontakt i Informacje',
    about: 'O Aplikacji',
    aboutDescription: 'GOPR Inventory to system zarządzania sprzętem ratownictwa górskiego, opracowany dla potrzeb Grupy Bieszczadzkiej GOPR.',
    contactInfo: 'Informacje Kontaktowe',
    company: 'Organizacja',
    companyName: 'Grupa Bieszczadzka GOPR',
    generalContact: 'Kontakt ogólny',
    technicalContact: 'Kontakt techniczny',
    otherProjects: 'Inne projekty',
    applicationInfo: 'Informacje o Aplikacji',
    versionInfo: 'Wersja: %s',
    changelog: 'Changelog / historia zmian',
  },
  changelog: {
    title: 'Historia zmian',
    intro: 'Rozwiń wersję, aby zobaczyć nowe funkcje i poprawki. Opisy zmian są prowadzone w języku polskim.',
    development: 'W przygotowaniu',
    major: 'Wersja główna %s',
    minorCount: 'Serie wersji: %s',
    releaseCount: 'Wydania: %s',
    current: 'Bieżąca wersja',
    empty: 'Historia zmian nie jest jeszcze dostępna.',
  },
  drawer: {
    contactLabel: 'Kontakt i Informacje',
    logout: 'Wyloguj',
  },
  reports: {
    title: 'Raporty',
    currentQuantityTitle: 'Stan magazynów',
    currentQuantityDescription: 'Aktualny stan ilościowy sprzętu we wszystkich magazynach.',
    usageRecordsTitle: 'Ewidencja użycia',
    usageRecordsDescription: 'Historia wszystkich operacji magazynowych z podziałem na sprzęt.',
    realUsageTitle: 'Rzeczywiste użycie sprzętu',
    realUsageDescription: 'Zużycie jednorazowych i liczba użyć wielorazowych w osobnych arkuszach, według magazynów i okresu.',
    requestButton: 'Generuj raport',
    requesting: 'Zlecam...',
    recentReports: 'Ostatnie raporty',
    noReports: 'Brak zleconych raportów.',
    statusPending: 'Oczekuje',
    statusDone: 'Gotowe',
    statusError: 'Błąd',
    emailNotice: 'Raport zostanie wygenerowany i wysłany na Twój adres email.',
    requestSuccess: 'Raport zlecony. Sprawdź skrzynkę email za chwilę.',
    requestError: 'Nie udało się zlecić raportu.',
    dateFromLabel: 'Od',
    dateToLabel: 'Do',
    datePlaceholder: 'DD.MM.RRRR',
    dateRangeError: 'Nieprawidłowy format daty (DD.MM.RRRR).',
    generatedBy: 'Wygenerowano przez',
    belowLimitTitle: 'Stany poniżej limitu',
    belowLimitDescription: 'Lista sprzętu, którego ilość w magazynie jest poniżej wymaganego minimum, z podziałem na magazyny.',
    refresh: 'Odśwież',
    downloadButton: 'Pobierz',
    systemLabel: 'System',
    recipientsLabel: 'Odbiorcy',
  },
  profile: {
    title: 'Mój profil',
    firstnameLabel: 'Imię',
    firstnamePlaceholder: 'Imię',
    lastnameLabel: 'Nazwisko',
    lastnamePlaceholder: 'Nazwisko',
    saveProfile: 'Zapisz profil',
    profileSaved: 'Profil zapisany.',
    profileSaveError: 'Nie udało się zapisać profilu.',
    firstnameRequired: 'Imię jest wymagane.',
    changePassword: 'Zmień hasło',
    currentPasswordLabel: 'Aktualne hasło',
    currentPasswordPlaceholder: 'Aktualne hasło',
    newPasswordLabel: 'Nowe hasło',
    newPasswordPlaceholder: 'Nowe hasło',
    confirmPasswordLabel: 'Potwierdź nowe hasło',
    confirmPasswordPlaceholder: 'Potwierdź nowe hasło',
    passwordChanged: 'Hasło zostało zmienione.',
    passwordChangeError: 'Nie udało się zmienić hasła.',
    passwordMismatch: 'Nowe hasła nie są zgodne.',
    currentPasswordRequired: 'Aktualne hasło jest wymagane.',
    newPasswordRequired: 'Nowe hasło jest wymagane.',
    newPasswordTooShort: 'Nowe hasło musi mieć co najmniej 6 znaków.',
    emailPasswordOnly: 'Zmiana hasła jest dostępna tylko dla kont email/hasło.',
    setPasswordDescription: 'Ustaw hasło, aby móc logować się zarówno przez Google, jak i przez email i hasło.',
    setPassword: 'Ustaw hasło',
    passwordSet: 'Hasło zostało ustawione. Możesz teraz logować się przez Google lub email i hasło.',
    passwordSetError: 'Nie udało się ustawić hasła.',
    passwordWeakError: 'Hasło jest zbyt słabe. Wybierz silniejsze hasło.',
    passwordAlreadyLinked: 'Konto email/hasło jest już przypisane do tego konta.',
  },
};

export default pl;
